
(() => {
  const initialized = new WeakSet();
  const mobile = matchMedia('(max-width:749px), (hover:none), (pointer:coarse)');
  function initialize(root = document) {
    root.querySelectorAll('wake-product-swipe').forEach(card => {
      if (initialized.has(card)) return;
      const track = card.querySelector('.wake-product-images');
      const slides = [...card.querySelectorAll('.wake-product-slide')];
      const dots = [...card.querySelectorAll('.wake-image-dots button')];
      if (!track || slides.length < 2) return;
      initialized.add(card);
      const updateDots = () => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      };
      const updateMode = () => {
        slides[1].tabIndex = mobile.matches ? 0 : -1;
        if (!mobile.matches) track.scrollLeft = 0;
        updateDots();
      };
      dots.forEach((dot, i) => dot.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        track.scrollLeft = i * track.clientWidth;
        updateDots();
      }));
      track.addEventListener('scroll', updateDots, {passive:true});
      let startX = 0;
      let moved = false;
      track.addEventListener('pointerdown', event => { startX = event.clientX; moved = false; }, {passive:true});
      track.addEventListener('pointermove', event => {
        if (mobile.matches && event.buttons && Math.abs(event.clientX - startX) > 10) moved = true;
      }, {passive:true});
      track.addEventListener('click', event => {
        if (!mobile.matches) return;
        if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; return; }
        if (track.scrollLeft < track.clientWidth / 2) {
          event.preventDefault();
          event.stopPropagation();
          track.scrollLeft = track.clientWidth;
          updateDots();
        }
      }, true);
      updateMode();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  mobile.addEventListener('change', () => {
    document.querySelectorAll('wake-product-swipe').forEach(card => {
      const secondary = card.querySelector('.wake-product-slide-secondary');
      if (secondary) secondary.tabIndex = mobile.matches ? 0 : -1;
      if (!mobile.matches) card.querySelector('.wake-product-images').scrollLeft = 0;
    });
  });
})();
